import { render } from "./todo.vue?vue&type=template&id=a5e5f9a6"
import script from "./todo.vue?vue&type=script&lang=js"
export * from "./todo.vue?vue&type=script&lang=js"

import "./todo.vue?vue&type=style&index=0&id=a5e5f9a6&lang=css"
script.render = render

export default script